/* eslint-disable camelcase */
import React from 'react';
import ReactTable from 'react-table';
import ActionButton from '../../common/ActionButton';

export type TAgencyTimesheetSummary = {
    agency_id: number;
    agency_name: string;
    awaiting_approval_count: number;
    auto_approved_count: number;
    approved_count: number;
    total_count: number;
};

type TPayrollAdminTableProps = {
    content: TAgencyTimesheetSummary[];
    loading: boolean;
    errorMsg?: string;
    onDownload: (agencyId: number) => void;
};

type TableCell<TData> = {
    original: TData;
};

export default function PayrollAdminTable({
    content,
    loading,
    errorMsg,
    onDownload,
}: TPayrollAdminTableProps) {
    const columns = [
        {
            Header: 'Agency',
            accessor: 'agency_name',
        },
        {
            Header: 'Awaiting Approval',
            accessor: 'awaiting_approval_count',
        },
        {
            Header: 'Auto Approved',
            accessor: 'auto_approved_count',
        },
        {
            Header: 'Approved',
            accessor: 'approved_count',
        },
        {
            Header: 'Total',
            accessor: 'total_count',
        },
        {
            Header: 'Download Approved Timesheets',
            sortable: false,
            Cell: (row: TableCell<TAgencyTimesheetSummary>) => (
                <ActionButton
                    text="Download CSV"
                    compact={true}
                    onAction={() => onDownload(row.original.agency_id)}
                />
            ),
        },
    ];

    return (
        <ReactTable
            className="table-content payroll-admin-table"
            loading={loading}
            data={content || []}
            columns={columns}
            pageSize={content ? content.length : 0}
            noDataText={errorMsg || 'No timesheets Found'}
            showPaginationBottom={false}
            showPageSizeOptions={false}
        />
    );
}
